import { createContext, useContext, useState, useEffect } from 'react';
import { getCurrentUser, logoutUser, touchLastSeen, supabase } from '../lib/supabase';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const u = getCurrentUser();
    setUser(u);
    if (u) touchLastSeen(u.id);
    setLoading(false);

    // Доступ закрыт (СВ уволен или заменён) — выходим, даже если вход ещё сохранён в браузере
    async function checkActive() {
      const cur = getCurrentUser();
      if (!cur) return;
      try {
        const { data, error } = await supabase.from('users').select('is_active').eq('id', cur.id).maybeSingle();
        if (error) return; // сеть/БД недоступна — не выкидываем
        if (!data || data.is_active === false) { logoutUser(); setUser(null); }
      } catch (e) { /* ignore */ }
    }
    checkActive();
    window.addEventListener('focus', checkActive);
    const timer = setInterval(checkActive, 5 * 60 * 1000);
    return () => { window.removeEventListener('focus', checkActive); clearInterval(timer); };
  }, []);

  const login = (userData) => {
    setUser(userData);
  };

  const logout = () => {
    logoutUser();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
